import colorfulBack from "./colorfulBack";
import dateFromNow from "./dateFromNow";
import delay from "./delay";

const utils = {colorfulBack, dateFromNow, delay, confirm};
export default utils;